<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-tabs v-model="active" type="border-card">
        <el-tab-pane name="1">
          <span slot="label"><i class="el-icon-user-solid"></i> 单项级部信息</span>
          <simple-grade-item />
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label"><i class="el-icon-s-grid"></i> 单项班级信息</span>
          <simple-class />
        </el-tab-pane>
        <el-tab-pane name="3">
          <span slot="label"><i class="el-icon-menu"></i> 级部对比</span>
          <grade-item />
        </el-tab-pane>
        <el-tab-pane name="4">
          <span slot="label"><i class="el-icon-menu"></i> 班级对比</span>
          <class-info />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
  import SimpleGradeItem from '@/views/fengyiSchool/examine/components/chartInfo/simpleGradeItem.vue';
  import SimpleClass from '@/views/fengyiSchool/examine/components/chartInfo/simpleClass.vue';
  import GradeItem from '@/views/fengyiSchool/examine/components/chartInfo/gradeItem.vue';
  import ClassInfo from '@/views/fengyiSchool/examine/components/chartInfo/classInfo.vue';

  export default {
    name: 'Chart',
    components: { SimpleClass, SimpleGradeItem, GradeItem, ClassInfo },
    data() {
      return {
        active: '1',
      };
    },
    methods: {},
  };
</script>

<style scoped></style>
